// extracted by mini-css-extract-plugin
export default {"wrapper":"e2-z","play":"f2-z"};